import { FilePreviewTypes } from '@ca/core/models';
// Name constants according to https://angular.io/guide/styleguide#constants

export const PERMISSION_APPLICATIONS = 'apeer.applications';
export const PERMISSION_MACHINELEARNING = 'apeer.machinelearning';
export const PERMISSION_MACHINELEARNING_OVERVIEW = 'apeer.machinelearning.overview';
export const PERMISSION_MACHINELEARNING_ANNOTATE = 'apeer.machinelearning.annotate';
export const PERMISSION_MACHINELEARNING_TRAIN = 'apeer.machinelearning.train';
export const PERMISSION_MACHINELEARNING_SEGMENT = 'apeer.machinelearning.segment';
export const PERMISSION_MACHINELEARNING_RESULT_VIEWRESULTDETAILS = 'apeer.machinelearning.result.viewresultdetails';
export const PERMISSION_COMMUNITYCONTENT = 'apeer.communitycontent';
export const PERMISSION_COMMUNITYCONTENT_PUBLICWORKFLOWS = 'apeer.communitycontent.publicworkflows';
export const PERMISSION_COMMUNITYCONTENT_PUBLICMODULES = 'apeer.communitycontent.publicmodules';
export const PERMISSION_MYLAB = 'apeer.mylab';
export const PERMISSION_MYLAB_WORKFLOWS = 'apeer.mylab.workflows';
export const PERMISSION_MYLAB_MODULES = 'apeer.mylab.modules';
export const PERMISSION_MYLAB_PROJECTS = 'apeer.mylab.projects';
export const PERMISSION_MYLAB_FILES = 'apeer.mylab.files';
export const PERMISSION_MYLAB_RESULTS = 'apeer.mylab.results';
export const PERMISSION_INFORMATION = 'apeer.information';
export const PERMISSION_INFORMATION_APEER = 'apeer.information.apeer';
export const PERMISSION_INFORMATION_DOCS = 'apeer.information.docs';
export const PERMISSION_INFORMATION_BLOG = 'apeer.information.blog';
export const PERMISSION_MYACCESSTOKENS = 'apeer.myaccesstokens';
export const PERMISSION_CONTACTUS = 'apeer.contactus';
export const PERMISSION_HOWTO = 'apeer.howto';
export const PERMISSION_USERPROFILE_SUBSCRIPTION = 'apeer.userprofile.subscription';
export const PERMISSION_VIEWER_INDUSTRY = 'apeer.viewer.industry';

export const sidebarAutoCollapseWidth = 767;
export const defaultBatchCorrelationId = '00000000-0000-0000-0000-000000000000';
export const fileDownloadThresholdInBytes = 249 * 1024 * 1024;
export const defaultPageSize = 10;
export const defaultPageNumber = 1;
export const defaultSortBy = '-createdAt';
export const HTTP_URL_PREFIX: string = 'http';
export const HTTP_URL_PREFIX_FULL: string = HTTP_URL_PREFIX + '://';
export const HTTPS_URL_PREFIX_FULL: string = 'https://';
export const MODULE_TITLE_PATTERN = /^[\-a-zA-Z0-9][\-a-zA-Z0-9_.\s-]{0,99}$/;
export const WORKFLOW_TITLE_PATTERN = /^[a-zA-Z0-9].*$/;
export const URL_PATTERN = /^https?:\/\/..*$/;
export const MAILTO_LINK_PREFIX = 'mailto';
export const USER_ROUTE_PART = '/user';
export const ADMIN_ROUTE_PART = '/admin';
export const RUNNER_ROUTE_PART = 'runner';
export const SUBMITTED_WORKFLOWS_ROUTE_PART = 'submitted-workflows';
export const USER_WORKSPACE_ROUTE = `${USER_ROUTE_PART}/workspace`;
export const USER_MODULES_ROUTE = `${USER_WORKSPACE_ROUTE}/modules`;
export const USER_WORKFLOW_DETAILS_ROUTE = `${USER_WORKSPACE_ROUTE}/workflows/detail`;
export const WORKFLOW_EDITOR_ROUTE_PART = '/workflow-editor';
export const WORKFLOW_EDITOR_ROUTE = `workflows${WORKFLOW_EDITOR_ROUTE_PART}`;
export const MACHINE_LEARNING_ROUTE_PART = '/ai-toolkit';
export const TRAIN_ROUTE_PART = '/my-models';
export const MACHINE_LEARNING_TRAIN_ROUTE = `${MACHINE_LEARNING_ROUTE_PART}${TRAIN_ROUTE_PART}`;
export const SEGMENT_ROUTE_PART = '/my-segmentations';
export const MACHINE_LEARNING_SEGMENT_ROUTE = `${MACHINE_LEARNING_ROUTE_PART}${SEGMENT_ROUTE_PART}`;
export const PROJECTS_ROUTE = `${USER_WORKSPACE_ROUTE}/projects`;
export const PUBLIC_MODULES_ROUTE = '/modules';
export const PUBLIC_WORKFLOWS_ROUTE = '/workflows';
export const WORKFLOW_DETAILS_ROUTE = '/workflows/detail';
export const APPLICATIONS_PATH = 'applications';
export const APPLICATIONS_ROUTE = `/${APPLICATIONS_PATH}`;
export const DIS_APEER_ROUTE = 'dis-apeer.com';
export const WIKI_URL = 'http://docs.apeer.com/';
export const ANNOTATION_GUIDE_URL = 'https://docs.apeer.com/machine-learning/annotation-guidelines';

export const WORKFLOW_SETTINGS_SERVICE_URL = '/api/documents/workflow';
export const MACHINE_LEARNING_SERVICE_URL = '/api/documents/machinelearning';
export const ARIVIS_VIEWER_API_SERVICE_URL = '/viewer/api';

export const APEER_BLOB_STORAGE_URL_PART = '.core.windows.net';
export const FILE_PREVIEW_TYPES: ReadonlyArray<FilePreviewTypes> = ['txt', 'csv', 'json', 'html', 'htm'];
export const MED_UNSUPPORTED_FILE_PREVIEW_TYPES: ReadonlyArray<FilePreviewTypes> = ['txt', 'csv', 'json', 'html', 'htm'];
export const BROWSER_SUPPORTED_TYPES = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'svg'];
// The supported types list is updated as of 2018-02-28 from Arivis.
export const FILE_TYPES_SUPPORTED_BY_ARIVIS: ReadonlyArray<string> = [
    'bmp',
    'czi',
    'dv',
    'dicom',
    'dcm',
    'gif',
    'giff',
    'hdr',
    'ics',
    'ids',
    'ims',
    'jfif',
    'jif',
    'jp2',
    'jpeg',
    'jpg',
    'lei',
    'lif',
    'mrxs',
    'nd2',
    'ndpi',
    'ndpis',
    'nii',
    'nii.gz',
    'oib',
    'oif',
    'png',
    'rl4',
    'rl8',
    'rle',
    'sis',
    'sld',
    'stk',
    'svs',
    'sys',
    'tif',
    'tiff',
    'tim',
    'vga',
    'vgi',
    'vms',
    'vol',
    'zvi',
];

export const CZI_EXTENSION = 'czi';

// This list is duplicated in the backend: DocumentService -> File.cs
export const FILE_TYPES_SUPPORTED_BY_APEER_MULTI_DOTS: string[] = ['nii.gz', 'ome.tiff', 'ome.tif', 'ome.tf2', 'ome.tf8', 'ome.btf', 'ome.xml'];

export const FILE_EXPLORER_MODE = { SELECTION: 'selection', MODIFICATION: 'modification' } as const;

export const UPLOADER_KEY = { MY_FILES_UPLOAD_UPLOADER_KEY: 'my_files_upload' } as const;
